module.exports = __webpack_public_path__ + "img/help-center.ffc7697d.svg";